export enum MemberPaymentMethodType {
  autogiro = 'autogiro',
  stripe = 'stripe',
  eInvoice = 'eInvoice',
}
